import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import queryString from 'query-string'


import logo from './images/logo.svg';
import background from './images/background3.jpg';
import './css/App.css';
import CenterComponent from './sub-components/center';
import DailyActivity from './sub-components/DailyActivity';
import DetailViewComponent from './sub-components/DetailViewComponent/jumperDetail';
import LoadManagerCenter from './sub-components/LoadManagerCenter';
import socketIOClient from "socket.io-client";
import loadsStore from "../stores/loads-store";
import jumpersStore from '../stores/jumpers-store';
import reportsStore from '../stores/report-store';
import authStore from "../stores/auth-store";
import urlgetter from '../services/getMainUrl';

import MyDropzone from './upload'

import login from './sub-components/login/Login';
import SignUp from './sub-components/signUp';
import Rigs from './sub-components/rigs';

import ResetPassword from './sub-components/login/ResetPassword';
import ForgotPassword from './sub-components/login/ForgotPassword'
import ActivityDetails from './sub-components/DailyActivity/ActivityDetails';
import LoginLoader from './sub-components/login/LoginLoader';
import LoadCallPage from './LoadCallPage/LoadCallContainer';
import StaffBoard from './StaffBoard/StaffBoard';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 'LOAD MANAGER',
      showModal: false,
      showLoader: true,
      ip: '',
      configLoaded :false
      //modalBody:<h1 style={{color:'white'}}>Currently Not available</h1>
    }
    this.handleGetIp = this.handleGetIp.bind(this);

    // this.noComponentCenter = <h1 style={{color:'white'}}>Currently Not available</h1>;
    // this.menu = {
    //   'LOAD MANAGER': {
    //     center: <LoadManagerCenter />,
    //     noMargin: false,
    //     style: {}
    //   }
    // }
    this.authEvents = [
      { name: authStore.getEventPrefix('loggedIn'), func: this.handleLogin },
      { name: authStore.getEventPrefix('getIp'), func: this.handleGetIp },
    ]
    this.loadEvents = [
      { name: loadsStore.getEventPrefix('configLoaded'), func: this.handleConfigLoaded },
    ]

    // this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  handleConfigLoaded = () => {
    //alert(JSON.stringify(window.ENV, null,2));
    this.setState({configLoaded: true})
  }
  // componentDidMount = () => {
  //     const socket = socketIOClient(urls.mainApiUrl);
  //     jumpersStore.loadAllJumpers()
  //       .then((jumpersLoaded) => {
  //         //console.log('after loadAll Jumpers');
  //         return jumpersStore.loadTandemStudents();
  //       })
  //       .then((studentsLoaded) => {
  //         //console.log("after load all students");
  //         return loadsStore.loadAllExistingLoads();
  //       })
  //       .then(loads => {
  //         loadsStore.setListeners(socket);
  //       })
  componentWillMount = () => {
  
    console.log('trying to get query');
    console.log(window.location.search) // "?filter=top&origin=im"
    const values = queryString.parse(window.location.search)
    console.log(values.username) // "top"
    console.log(values.password);
    if (values.username !== undefined && values.password != undefined) {
      authStore.login({ username: values.username, password: values.password })
        .then(data => {
          //console.log(data);
          if (data.success) {
            localStorage.setItem("isAuth", true);
            localStorage.setItem("Auth-token", data.token);
            //this.props.history.push('/load-manager')
          }
          else {
            if (data = 'Unauthorized') {
              this.setState({ Invalid: true });
              setTimeout(() => {
                this.setState({ Invalid: false });
              }, 3000);
            }
          }

        });
    }
  }


  // }

  // componentWillMount = () => {
  //   schedulesStore.on('ERROR', this.handleError)
  // }
  componentWillUnmount = () => {
    // document.removeEventListener('keypress', this.handleKeyDown);
    this.authEvents.forEach((evnt) => authStore.removeListener(evnt.name, evnt.func));
    this.loadEvents.forEach((evnt) => loadsStore.removeListener(evnt.name, evnt.func));

  }

  handleError = (e) => {
    if (e.alert) {
      //console.log(e.message);
    } else {
      //console.log(e.message);
    }
  }

  handleGetIp(data) {

    console.log('ip data');
    console.log(data);

    console.log(window.ENV?.localIp);

    var ip = authStore.getIpFromAuthStore();

    this.setState({ ip: ip });
  }

  loadInfo = () => {
    const socket = socketIOClient(urlgetter.getMainApiUrl());
    loadsStore.loadConfig();
    loadsStore.loadStudentPackages()
      .then(packages => {
        console.log('student packages loaded');
        return loadsStore.loadAltitudes()
      })
      .then(loads => {
        return loadsStore.loadFunJumpTypes();
      })
      .then(alts => {
        authStore.getSettingsByUser()
        return loadsStore.loadSettings()
      })
      .then(settings => {
        return jumpersStore.loadAllJumpers();
      })
      .then((jumpersLoaded) => {
        //console.log('after loadAll Jumpers');
        return jumpersStore.loadTandemStudents();
      })
      .then((studentsLoaded) => {
        //console.log("after load all students");
        return loadsStore.loadAllExistingLoads();
      })
      .then(loads => {
        return jumpersStore.loadAllDailyActivities()
      })
      .then(loads => {
        loadsStore.setListeners(socket);
        jumpersStore.setListeners(socket);
        authStore.setListeners(socket)
        authStore.dataLoaded(); // emit data loaded event
        loadsStore.initializeTextToSpeech();
        loadsStore.createWidget();
      })
  }
  componentDidMount = () => {
    // document.addEventListener('keypress', this.handleKeyDown);
    //authStore.getIp();

    this.authEvents.forEach((evnt) => authStore.on(evnt.name, evnt.func))
    this.loadEvents.forEach((evnt) => loadsStore.on(evnt.name, evnt.func))

    // if(authStore.isLoggedIn){
    this.loadInfo();

  }

  handleLogin = () => {
    //console.log('in handle login');

    this.loadInfo();
  }


  handleKeyDown(e) {
    if (e.keyCode === 37) {
      console.log('You pressed the left key!')
      document.getElementsByClassName('carousel-back-btn').click();
    }
    else if (e.keyCode === 39) {
      console.log('You pressed the right key!')
      document.getElementsByClassName('carousel-next-btn').click();
    }
  }
  // componentDidMount = () => {
  //   this.authEvents.forEach((evnt) => authStore.on(evnt.name, evnt.func))
  //   // if(authStore.isLoggedIn){
  //   const socket = socketIOClient(urls.mainApiUrl);
  //   jumpersStore.loadAllJumpers()
  //     .then((jumpersLoaded) => {
  //       //console.log('after loadAll Jumpers');
  //       return jumpersStore.loadTandemStudents();
  //     })
  //     .then((studentsLoaded) => {
  //       //console.log("after load all students");
  //       return loadsStore.loadAllExistingLoads();
  //     })
  //     .then(loads => {
  //       loadsStore.setListeners(socket);
  //     })

  // }

  // handleLogin = () => {
  //   //console.log('in handle login');

  //   const socket = socketIOClient(urls.mainApiUrl);
  //     jumpersStore.loadAllJumpers()
  //       .then((jumpersLoaded) => {
  //         //console.log('after loadAll Jumpers');
  //         return jumpersStore.loadTandemStudents();
  //       })
  //       .then((studentsLoaded) => {
  //         //console.log("after load all students");
  //         return loadsStore.loadAllExistingLoads();
  //       })
  //       .then(loads => {
  //         loadsStore.setListeners(socket);
  //       })
  // }

  // render() {
  //   var dynamicRenders = this.menu[this.state.selected];
  //   return (
  //     <div className="App row" style={{ backgroundImage: `url(${background})`, minHeight: '100vh', backgroundSize: 'cover' }}>
  //       <div className="col">
  //         <img src={logo} alt="logo" style={{ height: 60, margin: 'auto', display: 'block' }} />
  //         <CenterComponent renderThis={dynamicRenders} noMargin={dynamicRenders.noMargin||false} selected={this.state.selected} />
  //       </div>
  //     </div>
  //   );
  // }

  render() {

    var token = localStorage.getItem("Auth-token");
    var file1 = 'images/spaceland.JPG';
    var file2 = window.ENV?.backgroundUrl;
    let { showLoader } = this.state;

    return (
      <Router>
        {/* <div className="App row main-app" onKeyDown={(e)=>this.handleKeyDown(e)}> */}
        {this.state.configLoaded?<div className="App row ml-0" style={{ backgroundImage: `url(${file2})`, minHeight: '100vh', backgroundSize: 'cover', overflow: 'hidden' }}>
          <Route exact path="/" component={token === null && this.state.ip !== window.ENV?.localIp ? login : CenterComponent} />
          <Route path="/login" component={login} />
          <Route path="/signUp" component={SignUp} />
          <Route path="/forgot" component={ForgotPassword} />
          <Route path="/reset" component={ResetPassword} />
          <Route path="/upload_media" component={MyDropzone} />
          <Route path="/load-manager" component={CenterComponent} />
          <Route path="/rigs" component={Rigs} />
          <Route path="/daily-activity" exact component={DailyActivity} />
          <Route path="/daily-activity/details" component={ActivityDetails} />
          <Route path="/detail" component={DetailViewComponent} />
          <Route path="/loadcall" component={LoadCallPage} />
          <Route path="/staffboard" component={StaffBoard} />

        </div>:<div>config loading</div>}
      </Router>
    );
  }
}

export default App;
